
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visit/groups-and-tours",
      function () {
        return require("private-next-pages/visit/groups-and-tours/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visit/groups-and-tours"])
      });
    }
  